import { render, staticRenderFns } from "./ProcedureList.vue?vue&type=template&id=7f1a7062&"
import script from "./ProcedureList.vue?vue&type=script&lang=js&"
export * from "./ProcedureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports